import { defineComponent } from 'vue';

const oneMileInMeters = 1609.34;

export default defineComponent({
  delimiters: ['${', '}'],
  data() {
    return {
      search: '',
      google: null,
    };
  },
  computed: {
    isGoogleAvailable() {
      return this.$root.isGoogleAvailable;
    },
    googleMap() {
      return this.$root.googleMap;
    },
    radius() {
      return this.$store.getters.radius;
    },
    stockists() {
      return this.$store.getters.stockists;
    },
    filteredStockists() {
      return this.$store.getters.filteredStockists;
    },
    markers() {
      return this.$store.getters.markers;
    },
  },
  watch: {
    isGoogleAvailable() {
      this.setGoogle();
    }
  },
  mounted() {
    // Set the window.google variable when it is available
    this.setGoogle();
    // Reset filtered stockists
    this.$store.commit('setFilteredStockists', null);
    // reset the radius
    this.$store.commit('setRadius', null);
    // reset the zoom
    this.$store.commit('setMapZoom', 6);
  },
  methods: {
    geocodeLookup() {
      if (!this.googleMap && !this.geocoder && !this.search) {
        return;
      }
      this.geocoder
        .geocode({
          address: this.search,
          componentRestrictions: {
            country:'GB',
          },
        })
        .then((result) => {
          const { results } = result;
          const { location } = results[0].geometry;
          const coordinates = {
            lat: location.lat(),
            lng: location.lng(),
          }

          // No radius is set
          if (!this.radius) {
            this.$store.commit('setMapZoom', 11);
            this.$store.commit('setMapCenterCoordinates', coordinates);
            return;
          }

          // Radius is set from here onwards

          // Filter the stockists
          this.setFilteredStockists(coordinates);
          // No filtered stockists exist but move map anyway
          if (!this.filteredStockists || !this.filteredStockists.length) {
            this.$store.commit('setMapZoom', 11);
            this.$store.commit('setMapCenterCoordinates', coordinates);
            return
          }

          // Create bounds
          const bounds = new this.google.maps.LatLngBounds();
          for (let i = 0; i < this.markers.length; i++) {
            bounds.extend(this.markers[i].position);
          }
          this.googleMap.$mapObject.fitBounds(bounds);
          // Reset the center to include all the markers
          this.$store.commit('setMapCenterCoordinates', bounds.getCenter());
        })
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .catch((e: any) => console.error(`Geocode unsuccessful: ${e}`));
    },
    /**
     * Set filtered stockists
     * @param mapCenterCoordinates
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setFilteredStockists(mapCenterCoordinates: any) {
      // If no radius set, filtered stockists should show everything
      if (!this.radius) {
        this.$store.commit('setFilteredStockists', null);
        return;
      }
      const filteredStockists = this.stockists.filter((item) => {
        const { latitude, longitude } = item.coordinates;
        // Skip stockist if it has no coordinates
        if (!latitude || !longitude) {
          return false;
        }
        const filteredLatLng = {
          lat: latitude,
          lng: longitude,
        }
        const distanceBetween = this.google.maps.geometry.spherical.computeDistanceBetween(mapCenterCoordinates, filteredLatLng);
        item.distanceBetween = this.getMetersToMiles(distanceBetween);
        return (distanceBetween < this.radius * oneMileInMeters);
      }).sort((a, b) => {
        return parseFloat(a.distanceBetween) - parseFloat(b.distanceBetween);
      });
      this.$store.commit('setFilteredStockists', filteredStockists);
    },
    /**
     * Set the window.google variable when it is available
     */
    setGoogle() {
      if (!this.isGoogleAvailable) {
        return;
      }
      this.google = window.google;
      this.geocoder = new this.google.maps.Geocoder();
    },
    getMetersToMiles(value: number) {
      const miles = value / oneMileInMeters;
      const rounded = Math.round(miles * 10) / 10
      return rounded.toFixed(1);
    }
  },
  template: '#t-stockists-search',
});
